module.exports = __webpack_public_path__ + "img/20220520091337332ggc.657a45bd.jpg";